import {Link} from "react-router-dom"
import {title_lycee, slug_lycee, niveaux, niv_color} from "./config/Config"

export function Home () {

  let date = new Date()
  const tab_mois = [ "janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"]
  const mois = tab_mois[date.getMonth()]
  const anneeEnCours = date.getFullYear();

  const niveaux_btn = niveaux.map((niv, k)=>
          <span key={k} className={'niv'+(k+1)} style={{color:niv.color}} >
            <Link to={'/notions/'+niv.slug} title={'Niveau '+niv.title}>{niv.title}</Link>
          </span>)

  document.title = 'Automaths - Accueil'

  return (
    <>
    <h1>Automaths</h1>
      <div className="index_bienvenue">
        Bienvenue dans la partie <font color="#C8E162" size="+2"><strong><i>Automaths</i></strong></font>.<br/> 
        Cet exerciseur vous permet de travailler au quotidien les automatismes en mathématiques sous la forme de questions flash évaluées (activités rapides, rituels). <br/>
        Un professeur peut suivre les résultats de ses élèves, évaluer par différenciation, observer et analyser les erreurs les plus courantes de ses élèves, créer des questions et bien d'autres choses...<br/>
        Un certain nombre de questions se traitent mentalement, <b> <font color="#606060" size="+1">les autres nécessitent feuille/stylo et/ou calculatrice.</font> <br/>
        Avant utilisation de cette plate-forme, consulter :</b><br/>
        - la <a href="https://maths-au-quotidien.fr/automaths-notice.php"> <i><b>notice complète</b></i> 📄</a>
        <br/>
        - nos <a href="https://www.youtube.com/@MAQ-Automaths"> <b><i>vidéos </i></b>📹</a> de prise en main.
        <br/>
      </div>
      
      <div className="index_menu">
        {niveaux_btn.slice(0,5)}
      </div>

      <br/>
      <div className="index_menu lycee">
        {niveaux_btn.slice(5,8)}
      </div>

      <br/>
      <div className="index_menu lycee">
        {niveaux_btn.slice(8,17)}
      </div>

      <br/><br/><br/>
      
      <footer>
        Webmestres : A. Roumadni - M. Colonval - Orléans (45)
        <br/>
        © MAQ - Mise à jour {mois + ' ' + anneeEnCours}
        <br/>
        <a href="../legal.php"><font size="+0.5">Mentions légales</font></a> - <a href="../contact.php" title="Contact"><font size="+0.5">Contactez-nous</font></a>
      </footer>
    </>
  );
}